<template>
  <nav
    id="topNav"
    class="navbar sticky-top bg-custom-2"
  >
    <span class="mx-auto">
      <a
        id="container"
        class="navbar-brand mx-auto text-dark font-weight-bold"
        style="letter-spacing: 0.3em; font-family: Times New Roman, Times, serif;"
        href="#"
      >Muzik Dreamer

        <span id="disc"></span>

      </a>
      <!-- <sup class="pl-1 text-dark font-weight-bold">beta</sup> -->
    </span>
  </nav>
  <!-- <vue-navigation-bar
    class="sticky-top bg-custom-2"
    id="nav-bar"
    :options="navbarOptions"
  /> -->
</template>

<script>
import VueNavigationBar from "vue-navigation-bar";
import "vue-navigation-bar/dist/vue-navigation-bar.css";

export default {
  name: "HelloWorld",
  components: {
    VueNavigationBar,
  },
  data() {
    return {
      navbarOptions: {
        elementId: "main-navbar",
        isUsingVueRouter: true,
        mobileBreakpoint: 992,
        brandImagePath: "./",
        brandImage: require("@/assets/logo.png"),
        brandImageAltText: "brand-image",
        // collapseButtonImageOpen: require('../src/assets/images/collapse-menu-dark.png'),
        // collapseButtonImageClose: require('../src/assets/images/times.png'),
        showBrandImageInMobilePopup: true,
        ariaLabelMainNav: "Main Navigation",
        tooltipAnimationType: "shift-away",
        menuOptionsLeft: [
          {
            type: "link",
            text: "Muzik Dreamer",
            subMenuOptions: [
              {
                isLinkAction: true,
                type: "link",
                text: "About",
                subText:
                  "Stupid corporate wet blankets. Like booze ever killed anyone.",
                path: "./about",
                iconLeft: '<i class="fa fa-star fa-fw"></i>',
              },
              {
                type: "hr",
              },
              {
                type: "link",
                text: "Locations",
                subText: "You're a presentation tool!",
                path: "./locations",
                iconLeft: '<i class="fa fa-star fa-fw"></i>',
              },
              {
                type: "hr",
              },
              {
                type: "link",
                text: "Blog",
                subText:
                  "I enjoy having breakfast in bed. I like waking up to the smell of bacon. Sue me.",
                path: "./blog",
                iconLeft: '<i class="fa fa-star fa-fw"></i>',
              },
            ],
          },
          {
            type: "link",
            text: "Contact",
            subMenuOptions: [
              {
                type: "link",
                text: "Customer Service",
                path: "./customer-service",
              },
              {
                type: "link",
                text: "Accounting",
                path: "./accounting",
              },
              {
                type: "hr",
              },
              {
                type: "link",
                text: "Reception",
                path: "./reception",
                iconLeft:
                  '<svg id="i-telephone" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"> <path d="M3 12 C3 5 10 5 16 5 22 5 29 5 29 12 29 20 22 11 22 11 L10 11 C10 11 3 20 3 12 Z M11 14 C11 14 6 19 6 28 L26 28 C26 19 21 14 21 14 L11 14 Z" /> <circle cx="16" cy="21" r="4" /> </svg>',
              },
            ],
          },
          {
            type: "link",
            text: "About Us",
            path: "./pricing",
            iconRight: '<i class="fa fa-long-arrow-right fa-fw"></i>',
          },
        ],
        // menuOptionsRight: [
        //   {
        //     type: "button",
        //     text: "Signup",
        //     path: "./signup",
        //     class: "button-red"
        //   },
        //   {
        //     type: "button",
        //     text: "Login",
        //     path: "./login",
        //     iconRight:
        //       '<svg id="i-arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"> <path d="M22 6 L30 16 22 26 M30 16 L2 16" /> </svg>'
        //   }
        // ]
      },
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.bg-custom-2,
.vnb__sub-menu-options {
  background-color: #0abcf9;
  background-image: linear-gradient(315deg, #0abcf9 0%, #2c69d1 74%) !important;

  /* background-image: linear-gradient(15deg, #e6ae37 0%, #80d0c7 100%); */
  /* background-image: linear-gradient(15deg, #13547a 0%, #80d0c7 100%); */
}

.vnb__sub-menu-options,
.vnb__menu-options__option__link,
.vnb__menu-options__option__link_text-wrapper {
  color: white !important;
}

#nav-bar {
  /* background: silver !important; */
  /* background-color: black; */
}

.vnb .button-red {
  background: #ff3b30 !important;
}

.vnb .button-red:hover {
  background: #fc0d00 !important;
}

#container {
  padding-left: 40px;
  padding-right: 230px;
  height: 40px;
  width: 40px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 24px;
  position: relative;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
  transition: 0.5s linear;
}
#container:before {
  content: "\f001";
  font-family: FontAwesome;
  font-size: 30px;
  background: -webkit-linear-gradient(50deg, #fd9f85 50%, #e837c2);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: #ff7e24;
  position: absolute;
  line-height: 30px;
  left: 8px;
}
#container:hover #disc {
  margin-left: 250px;
  transform: rotate(360deg);
  opacity: 1;
}
#disc {
  left: 5px;
  position: absolute;
  height: 40px;
  width: 40px;
  z-index: 1;
  opacity: 0.6;
  border-radius: 50%;
  background: transparent;
  margin: -5px;
  transition: 1.9s linear;
  box-shadow: 0 8px 6px -8px rgba(0, 0, 0, 0.5), 0 0 1px 1px rgba(0, 0, 0, 0.5),
    0 -34px 0px -25px #444 inset, 0 0 0 9px #333 inset, 0 0 0 10px #222 inset,
    0 -35px 0px -23px #444 inset, 0 0 0 12px #222 inset, 0 0 0 13px #333 inset,
    0 -36px 0px -21px #444 inset, 0 0 0 15px #333 inset, 0 0 0 16px #222 inset,
    0 0 0 55px #af2a10 inset, 0 0 0 47px #333 inset, 0 0 0 62px #af2a10 inset,
    0 0 10px 78px rgba(0, 0, 0, 0.5) inset;
}
</style>
